<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
import { login } from '@/api/api';
import store from '@/store';
export default {
  name: 'App',
  methods: {
    async getList(){
    
    let res=await login('/getHomePage',{
        companyID:store.state.companyID
      })
        // console.log(res,'res');
     
        let{lunboList,content,logo,productList
}=res.data
      let arr=[];
      let product=[]
      lunboList.forEach(item=>{
         item=store.state.imgUrl+item;
         arr.push(item)
      })
      productList.forEach(item=>{
        item.picpath=store.state.imgUrl+item.picpath;
        product.push(item)
      })

      this.lunboList=arr;
      this.gongsijianjie=content;
      logo? logo=store.state.imgUrl+logo:logo=""
     
      console.log(123456);
      // 修改store轮播
     store.commit('CHANGE_LUNboList',arr)
    //  公司简介
    store.commit('CHANGE_GONGSIJIANJIE',content)
    //公司简介图片
    store.commit('CHANGE_GONGSIPIC',logo)
    // 商品
    store.commit('CHANGE_PRODUCTLIST',product)
      
    
    
    },
    async getfooterInfo(){
      let res=await login('getphone',{
        companyID:store.state.companyID
      })
      let footerInfo=res.data
      // console.log(res.data,'res1');
     let logo=store.state.imgUrl+res.data.companypic6;
      // CHANGE_COMPANYPIC
      let list=res.data
      list.companypic1=store.state.imgUrl+res.data.companypic1;
      list.companypic2=store.state.imgUrl+res.data.companypic2;
      list.companypic3=store.state.imgUrl+res.data.companypic3;
      list.companypic4=store.state.imgUrl+res.data.companypic4;
      list.companypic5=store.state.imgUrl+res.data.companypic5;
      store.commit('CHANGE_COMPANYPIC',list);
      console.log(logo);
      store.commit('CHANGE_LOGO',logo);
      store.commit('CHANGE_footerInfo',footerInfo);
      // console.log(store.state.companypic);
     
     
    }
},
created(){
      
      this.getList();
      this.getfooterInfo()
  },

}


</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue